import { CircularProgress } from '@material-ui/core';
import { ProgressOverlay as ProgressOverlayContainer } from './ProgressOverlay.styles';
import { useStyles } from './ProgressOverlay.styles';
import { COLORS } from 'shared/constants/COLORS';

type ProgressOverlayProps = {
  progress: number;
};

export const ProgressOverlay = ({ progress }: ProgressOverlayProps) => {
  const classes = useStyles();
  return (
    <ProgressOverlayContainer>
      <svg width="0" height="0">
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor={COLORS.PRIMARY} />
          <stop offset="90%" stopColor={COLORS.PRIMARY} />
        </linearGradient>
      </svg>
      {progress === 100 ? (
        <CircularProgress thickness={3} classes={{ circle: classes.circle }} />
      ) : (
        <>
          <CircularProgress thickness={3} variant="determinate" value={progress} classes={{ circle: classes.circle }} />
          <p style={{ position: 'absolute', fontSize: 12 }}>{`${Math.round(progress)}%`}</p>
        </>
      )}
    </ProgressOverlayContainer>
  );
};
